import styled from 'styled-components';
// import i18n from '../../../language/i18n';
import { useTranslation } from 'react-i18next';

import { Button, Space, Drawer, message, notification } from 'antd';
import {
  MenuUnfoldOutlined,
  CloseOutlined,
  ImportOutlined,
} from '@ant-design/icons';

import { useDispatch, useSelector } from 'react-redux';
import { setLanguage } from '../../../features/language/languageSlice';

import { NavList, SearchContainer, Logo, User } from './components';
import nav_list from './components/nav_list';
import { Link, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  currentToken,
  currentUser,
  userLogout,
  setUser,
  isCompany,
} from '../../../features/user/userSlice';

import { ADDreportIcon } from '../../../icons';
import { getPersonalInfo } from '../../../api/User';
import { useLocation } from 'react-router';
import {useQueryClient} from "react-query";


const NavigationBarContainer = styled.div`
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
`;

const PCcontral = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const MobileContral = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Footer = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const user = useSelector(currentUser);
  const queryClient = useQueryClient()
  const navigate = useNavigate();
  const changeLanguage = () => {
    if (i18n.language === 'en') {
      dispatch(setLanguage('zh'));
    } else {
      dispatch(setLanguage('en'));
    }
  };

  const signOut = () => {
    queryClient.removeQueries()
    dispatch(userLogout());
  };

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      {/* <div
        onClick={changeLanguage}
        style={{ userSelect: 'none', cursor: 'pointer' }}
      >
        <TranslationOutlined /> {t('changeLanguage')}
      </div> */}
      {user && user.user ? (
        <div onClick={signOut}>
          <ImportOutlined /> {t('logout')}
        </div>
      ) : null}
    </div>
  );
};

const DrawerMenu = ({ visible, toggleDrawerMenu }) => {
  const { t } = useTranslation();
  const user = useSelector(currentUser);
  const token = useSelector(currentToken);
  const _isCompany = useSelector(isCompany);
  const navigate = useNavigate();
  const onClose = () => {
    toggleDrawerMenu();
  };

  const toAddReport = async () => {
    if (!token) {
      navigate('/login');
      toggleDrawerMenu();
      return message.warning('Please login first');
    } else {
      if (!user.user.wallet_address || user.user.wallet_address === '') {
        const { code, data } = await getPersonalInfo();
        if (code === '10000') {
          if (data.hacker.wallet_address) {
            const user = JSON.parse(localStorage.getItem('user'));
            user.user.wallet_address = data.hacker.wallet_address;
            dispatch(setUser(user));
            toggleDrawerMenu();
            navigate('/addreport');
          } else {
            toggleDrawerMenu();
            return notification.warning({
              key: 'warning',
              description: (
                <span
                  style={{
                    fontSize: '16px',
                  }}
                >
                  Please set your wallet address before submitting your report.
                </span>
              ),
              btn: (
                <Button
                  size="small"
                  style={{
                    height: '32px',
                    backgroundColor: '#18EAC4',
                    borderColor: '#18EAC4',
                    color: '#000',
                    borderRadius: '6px',
                  }}
                  onClick={() => {
                    notification.close('warning');
                    navigate('/user?page=my_info', { state: { wallet_address: true } });
                  }}
                >
                  Setting
                </Button>
              ),
            });
          }
        }
      } else {
        toggleDrawerMenu();
        navigate('/addreport');
      }
    }
  };
  return (
    <Drawer
      title={
        <Space direction="horizontal" align="center" size={'middle'}>
          {!_isCompany && (
            <Button type="text" icon={<ADDreportIcon />} onClick={toAddReport}>
              <span
                style={{
                  color: '#fff',
                  paddingLeft: '10px',
                  cursor: 'pointer',
                }}
              ></span>
              {t('breadcrumb.addreport')}
            </Button>
          )}
        </Space>
      }
      placement={'left'}
      closable={false}
      onClose={onClose}
      open={visible}
      footer={<Footer />}
      className="moblie-link-list"
      extra={
        <Space direction="horizontal" align="center" size={'middle'}>
          <Button
            shape="round"
            onClick={toggleDrawerMenu}
            icon={<CloseOutlined />}
          />
        </Space>
      }
      key={'left'}
    >
      {nav_list.map((item, index) => {
        return (
          <Link
            className="moblie-link-list-item"
            to={item.link}
            key={index}
            onClick={toggleDrawerMenu}
          >
            {t(item.tag)}
          </Link>
        );
      })}
    </Drawer>
  );
};

const NavigationBar = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [drawerMenuVisible, setDrawerMenuVisible] = useState(false);
  const [isMoblie, setIsmoblie] = useState(false);
  const token = useSelector(currentToken);
  const user = useSelector(currentUser);
  const _isCompany = useSelector(isCompany);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleDrawerMenu = () => {
    setDrawerMenuVisible(!drawerMenuVisible);
  };

  const changeLanguage = () => {
    if (i18n.language === 'en') {
      dispatch(setLanguage('zh'));
    } else {
      dispatch(setLanguage('en'));
    }
  };

  const gotoAddReport = async () => {
    if (!token) {
      navigate('/login?redirect_url='+location.pathname);
      // navigate('/login');
      return message.warning('Please login first');
    } else {
      if (!user.user.wallet_address || user.user.wallet_address === '') {
        const { code, data } = await getPersonalInfo();
        if (code === '10000') {
          if (data.hacker.wallet_address) {
            const user = JSON.parse(localStorage.getItem('user'));
            user.user.wallet_address = data.hacker.wallet_address;
            dispatch(setUser(user));
            navigate('/addreport');
          } else {
            return notification.warning({
              key: 'warning',
              description: (
                <span
                  style={{
                    fontSize: '16px',
                  }}
                >
                  Please set your wallet address before submitting your report.
                </span>
              ),
              btn: (
                <Button
                  size="small"
                  style={{
                    height: '32px',
                    backgroundColor: '#18EAC4',
                    borderColor: '#18EAC4',
                    color: '#000',
                    borderRadius: '6px',
                  }}
                  onClick={() => {
                    notification.close('warning');
                    navigate('/user?page=my_info', { state: { wallet_address: true } });
                  }}
                >
                  Setting
                </Button>
              ),
            });
          }
        }
      } else {
        navigate('/addreport');
      }
    }
  };

  const resizeChange = (e) => {
    e.preventDefault();
    const el = document.documentElement;
    if (el.clientWidth < 1300) {
      setIsmoblie(true);
    } else {
      setIsmoblie(false);
    }
  };

  useEffect(() => {
    const el = document.documentElement;
    if (el.clientWidth < 1300) {
      setIsmoblie(true);
    } else {
      setIsmoblie(false);
    }
    window.addEventListener('resize', resizeChange, { passive: false });
    return () => {
      window.removeEventListener('resize', resizeChange);
    };
  }, []);

  return (
    <NavigationBarContainer>
      {isMoblie ? (
        <MobileContral>
          <Space direction="horizontal" align="center" size={'middle'}>
            <Logo />
          </Space>
          <Space direction="horizontal" align="center" size={'middle'}>
            <User />
            <Button
              style={{
                fonsize: '24px',
              }}
              size="large"
              onClick={toggleDrawerMenu}
            >
              <MenuUnfoldOutlined />
            </Button>
            <DrawerMenu
              visible={drawerMenuVisible}
              toggleDrawerMenu={toggleDrawerMenu}
            />
          </Space>
        </MobileContral>
      ) : (
        <PCcontral>
          <Space direction="horizontal" align="center" size={'small'}>
            <Logo />
            <NavList />
            <SearchContainer />
          </Space>
          <Space direction="horizontal" align="center" size={'middle'}>
            {!_isCompany && (
              <Button
                type="text"
                onClick={gotoAddReport}
                style={{
                  color: '#fff',
                }}
                icon={<ADDreportIcon />}
              >
                {t('breadcrumb.addreport')}
              </Button>
            )}
            {/* <div
            onClick={changeLanguage}
            style={{ color: '#fff', userSelect: 'none', cursor: 'pointer' }}
          >
            <TranslationOutlined /> {t('changeLanguage')}
          </div> */}
            <User />
          </Space>
        </PCcontral>
      )}
    </NavigationBarContainer>
  );
};

export default NavigationBar;
